__webpack_require__.p = "https://lighthouse.uni-kiel.de/";